<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar construção"
             col-md="col-md-6" offset="3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label><strong>Imóvel: <span class="text-danger font-bold">*</span></strong></label>
              <p class="font-bold">{{ imovelDescricao }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicio" dateFormat="dd/mm/yyyy"
                            @update:modelValue="atualizarDataPrevisao"
                            :invalid="campoVazio.includes('data_inicio')"/>
                <label for="data_inicio">
                  <strong>Data de Inicio: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="tempo_construcao" v-model="dado.tempo_construcao" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }" @update:modelValue="atualizarDataPrevisao"
                             :invalid="campoVazio.includes('tempo_construcao')"/>
                <label for="tempo_construcao">
                  <strong>Tempo Construção: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino_previsao" v-model="dado.data_termino_previsao" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTerminoPrevisao" disabled
                            dateFormat="dd/mm/yyyy"/>
                <label for="data_termino_previsao"><strong>Previsão Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino" v-model="dado.data_termino" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTermino" dateFormat="dd/mm/yyyy"/>
                <label for="data_termino"><strong>Data de Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="previsao_orcamentaria" v-model="dado.previsao_orcamentaria" size="small"
                             style="width: 100%"
                             :invalid="campoVazio.includes('previsao_orcamentaria')"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="previsao_orcamentaria">
                  <strong>Previsão Orçamentária: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="orcamento_final" v-model="dado.orcamento_final" size="small" style="width: 100%"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="orcamento_final">
                  <strong>Orçamento Final: </strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import moment from 'moment';
import {apiRequest, calculoDataPrevisao, denormalizeDates, normalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "EditarConstrucao",
  components: {
    BaseModal,
  },
  props: {
    imovelDescricao: String,
    itemKey: String,
  },
  emits: ["fechar", "atualizarDados"],
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
    }
  },
  methods: {
    parseMoeda(valor) {
      if (!valor) return 0;
      return Number(valor.replace(/\./g, "").replace(",", "."));
    },
    atualizarDataPrevisao() {
      const {data_inicio, tempo_construcao} = this.dado;
      if (data_inicio && tempo_construcao !== "") {
        this.dado.data_termino_previsao = calculoDataPrevisao(data_inicio, tempo_construcao).replaceAll('/', '-');
      } else {
        this.dado.data_termino_previsao = null;
      }
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.construcoes.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        this.dado.previsao_orcamentaria = this.parseMoeda(this.dado.previsao_orcamentaria);
        this.dado.orcamento_final = this.parseMoeda(this.dado.orcamento_final);
        normalizeDates(this.dado, ['data_inicio', 'data_termino', 'data_termino_previsao']);

      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_termino', 'data_termino_previsao']);
      const resultado = await apiRequest("PATCH", apiUrl.construcoes.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        ['data_inicio', 'data_termino', 'data_termino_previsao', 'imovel'].forEach(field => {
          if (field === 'imovel') {
            resultado.data[field] = this.imovelDescricao;
          } else {
            resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY')
          }
        });
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    Inputmask("99/99/9999").mask(this.$refs.dataInicio.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTermino.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTerminoPrevisao.$el.querySelector("input"));
  },
}
</script>
